import React from 'react';
import { motion } from 'framer-motion';
import { Check, MessageCircle, GitBranch, RefreshCw } from 'lucide-react';
export function OfferSection() {
  const items = [{
    title: 'El Mapa 5R',
    desc: 'Rompe el hielo → Relevancia → Resultado → Riesgo → Ruta. Tu estructura base.',
    icon: <GitBranch className="w-6 h-6 text-[#0B6B3A]" data-id="element-112" />
  }, {
    title: '25 respuestas listas',
    desc: 'Para copiar y pegar. Ordenadas por fase y por intención del cliente.',
    icon: <MessageCircle className="w-6 h-6 text-[#0B6B3A]" data-id="element-113" />
  }, {
    title: 'Árbol de objeciones',
    desc: '¿Precio? ¿Está caro? ¿Lo voy a pensar? Tú solo eliges la rama y respondes.',
    icon: <Check className="w-6 h-6 text-[#0B6B3A]" data-id="element-114" />
  }, {
    title: 'Follow-up sin vergüenza',
    desc: '7 mensajes para reactivar chats sin perseguir a nadie y sin perder dignidad.',
    icon: <RefreshCw className="w-6 h-6 text-[#0B6B3A]" data-id="element-115" />
  }];
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-116">
      <div className="max-w-5xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-118">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1A1A1A] mb-4" data-id="element-119">
            Lo que recibes por <span className="text-[#0B6B3A]" data-id="element-120">$6.39</span>
          </h2>
          <p className="text-gray-600" data-id="element-121">
            Todo lo que necesitas para transformar tus chats en ventas.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-122">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow hover:border-[#0B6B3A]" data-id="element-123">
              <div className="w-12 h-12 bg-[#DCF8C6] rounded-lg flex items-center justify-center mb-4" data-id="element-124">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-[#1A1A1A] mb-2" data-id="element-125">
                {item.title}
              </h3>
              <p className="text-gray-600" data-id="element-126">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}